import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-links'>
        <div className='social-media-wrap'>
          <div className='social-icons'>
            <Link
              className='social-icon-link'
              to='https://www.linkedin.com/in/owenjrjones/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i className='fab fa-linkedin' />
            </Link>
            <Link
              className='social-icon-link'
              to='https://github.com/owenjrjones/'
              target='_blank'
              aria-label='GitHub'
            >
              <i className='fab fa-github' />
            </Link>
          </div>
          <p className='website-rights'>Owen Jones © 2024</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
